import { Article, Issue } from '../../../constants';
import { useIssues, useArticles } from '../../../hooks/use-issue';

export function useLoad(): GetIssuesResponse {
	const issuesResponse = useIssues();
	const articlesResponse = useArticles({ isFeatured: true });

	return {
		issues: issuesResponse.issues,
		articles: articlesResponse.articles,
		isLoading: issuesResponse.isLoading || articlesResponse.isLoading,
		error: issuesResponse.error || articlesResponse.error,
	};
}

export interface GetIssuesResponse {
	issues: Array<Issue>;
	articles: Array<Article>;
	isLoading: boolean;
	error?: Error | null;
}
